module.exports = __webpack_public_path__ + "static/media/red-coris-wrasse.0f2f2c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/red-coris-wrasse.png
// module id = 331
// module chunks = 0